import script from "./ManageUserRolesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageUserRolesPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__